import { useTemplateList } from './useTemplateList'
import * as React from 'react'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import type { UseListResult } from '../useList'
import type { Template } from '@ztechapps/common.contract'

export function useTemplateSelect({ filter, templateCategory }: { filter?: Record<any, any>; templateCategory: string }): UseListResult<Template> {
  const listResult = useTemplateList({
    filter: {
      ...filter,
      category: templateCategory,
    },
    sort: { name: 1 },
  })

  const list = listResult?.list
  const result = React.useMemo(() => {
    if (!isEmpty(list)) {
      return map(list, (item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.value,
        }
      })
    }
  }, [list])

  return {
    ...listResult,
    list: result,
  }
}

export function useTemplateSelectOptions<T = Template>({ filter, templateCategory }: { filter?: Record<any, any>; templateCategory: string }) {
  const { list } = useTemplateSelect({ filter, templateCategory })

  return (list ?? []) as T[]
}
